function getValidTotal(total) {
    var pageTotal = Number(total);
    return isNaN(pageTotal) || pageTotal < 0 ? 0 : Math.floor(pageTotal);
}

function isValidCurrentIndex(current, total) {
    var pageTotal = getValidTotal(total);
    var currentIndex = Number(current);

    if (pageTotal <= 0 || isNaN(currentIndex) || currentIndex < 0 || currentIndex >= pageTotal) {
        return false;
    }

    return true;
}

function getSafeCurrentIndex(current) {
    return Math.floor(Number(current));
}

function canTurnPage(total) {
    return getValidTotal(total) > 1;
}

function canAutoTurnPage(total, autoplayDuration) {
    var duration = Number(autoplayDuration);
    return canTurnPage(total) && !isNaN(duration) && duration > 0;
}

function getNextPageIndex(current, total) {
    var pageTotal = getValidTotal(total);

    if (pageTotal <= 1) {
        return 0;
    }

    if (!isValidCurrentIndex(current, pageTotal)) {
        return 0;
    }

    return (getSafeCurrentIndex(current) + 1) % pageTotal;
}

function getPrevPageIndex(current, total) {
    var pageTotal = getValidTotal(total);

    if (pageTotal <= 1) {
        return 0;
    }

    if (!isValidCurrentIndex(current, pageTotal)) {
        return pageTotal - 1;
    }

    return (getSafeCurrentIndex(current) - 1 + pageTotal) % pageTotal;
}

module.exports = {
    canAutoTurnPage: canAutoTurnPage,
    canTurnPage: canTurnPage,
    getNextPageIndex: getNextPageIndex,
    getPrevPageIndex: getPrevPageIndex,
};
